import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function AIBlueprints() {
  const page = getSemanticPageByPath('/ai-blueprints');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
